import React, { useState, useEffect } from "react";
import { Col, message, Row, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
// component
import { Loading } from "../../component/loading";
import BranchStaffSearch from "./component/branch_staff_search";
import BranchStaffListing from "./component/branch_staff_listing";
import DialogStaffAdd from "./dialog/dialog_staff_add";
// redux
import {
  snapStaffs,
  unSnapStaffs,
  getStaffByIds,
  emptyStaffs,
} from "../../store/staff/staff.action";
import { snapDetail, unSnapDetail } from "../../store/branch/branch.action";
import { detailSelector } from "../../store/branch/branch.selector";
import { staffSelector, infosSelector } from "../../store/staff/staff.selector";

const BranchStaff = () => {
  // -------------------------- VAR --------------------------
  const params = useParams();
  const id = params.id || "";
  // -------------------------- STATE --------------------------
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [search, setSearch] = useState("");
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const staffs = useSelector(staffSelector);
  const infoStaffs = useSelector(infosSelector);
  const branch = useSelector(detailSelector);

  // -------------------------- FUNCTION --------------------------
  const handleClick = () => {
    setOpen(true);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
  };

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (id !== "") {
      dispatch(
        snapStaffs({ branch: id }, () => {
          setLoading(false);
        })
      );
      dispatch(snapDetail({ id }));
    }

    return () => {
      dispatch(unSnapStaffs());
      dispatch(unSnapDetail());
    };
  }, [dispatch, id]);

  useEffect(() => {
    if (staffs?.length > 0) {
      const ids = staffs?.map((item) => item.staff);
      dispatch(
        getStaffByIds({ ids }, (response) => {
          if (response.status === 500) {
            message.error(response?.data);
          }
        })
      );
    } else {
      dispatch(emptyStaffs());
    }
  }, [dispatch, staffs]);

  //import data
  useEffect(() => {
    if (infoStaffs) {
      setData(infoStaffs);
    }
  }, [infoStaffs]);

  //filter
  useEffect(() => {
    let data = infoStaffs || [];
    if (search !== "") {
      data = data?.filter((item) => {
        const lowerSearch = search.toLowerCase();
        const fullName = `${item?.firstName} ${item?.lastName} | ${item?.preferredName}`;
        const lowerFullName = fullName.toLowerCase();
        const valids = lowerFullName.includes(lowerSearch);
        return valids;
      });
    }

    setData(data);
  }, [search]);

  // -------------------------- DATA FUNCTION --------------------------
  // -------------------------- RENDER --------------------------

  const renderTopBar = () => {
    return (
      <Row gutter={[16, 12]}>
        <Col lg={10} md={10} sm={12} xs={24}>
          {renderLeft()}
        </Col>
        <Col align="right" lg={14} md={14} sm={12} xs={24}>
          {renderRight()}
        </Col>
      </Row>
    );
  };

  const renderLeft = () => {
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <span style={{ marginRight: 20 }} className="voucher-header">
          Staff
        </span>
        <BranchStaffSearch handleChange={handleSearch} />
      </div>
    );
  };

  const renderRight = () => {
    return (
      <div>
        <span style={{ marginRight: 20, fontWeight: "bold" }}>
          Total Staff: {data?.length || 0}
        </span>
        <Button icon={<PlusOutlined />} type="primary" onClick={handleClick}>
          Add Staff
        </Button>
      </div>
    );
  };

  const renderList = () => {
    return (
      <Row justify="end" align="middle" gutter={[16, 16]}>
        <Col lg={24} md={24} sm={24} xs={24}>
          {loading ? (
            <Loading />
          ) : (
            <BranchStaffListing data={data} staffs={staffs} />
          )}
        </Col>
      </Row>
    );
  };

  const renderModal = () => {
    return (
      <DialogStaffAdd
        open={open}
        setOpen={setOpen}
        data={data}
        branch={branch}
      />
    );
  };

  // -------------------------- MAIN --------------------------

  return (
    <Row gutter={[16, 5]}>
      <Col xl={24} lg={24} md={24} xs={24}>
        {renderTopBar()}
        {renderList()}
        {renderModal()}
      </Col>
    </Row>
  );
};

export default BranchStaff;
